/** @jsx isolateComponent */

import { Checkbox, FlexLayout } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { Text } from '@zapier/design-system';

type DowngradeQuestionProps = {
  /** Is the checkbox checked */
  isChecked: boolean;
  /** Function called when checkbox is toggled */
  onToggle: (qid: any) => void;
  /** The question text */
  question: string;
};

export const DowngradeQuestion = ({
  isChecked,
  onToggle,
  question,
}: DowngradeQuestionProps) => {
  return (
    <FlexLayout gutter="small" wrap="no-wrap">
      <Checkbox checked={isChecked} onChange={onToggle} />

      <Text color="grey900" type="bodyText800">
        {question}
      </Text>
    </FlexLayout>
  );
};
